module.exports = __webpack_public_path__ + "img/ent1.262156c6.png";